// extracted by mini-css-extract-plugin
export default {"input":"JobSearchPage_input__uFFCr","selectBox":"JobSearchPage_selectBox__cVqcy","filterBox":"JobSearchPage_filterBox__tNEbC"};